module.exports = __webpack_public_path__ + "img/companyApplyen.c7a0b699.jpg";